export const SET_IS_THE_OLD_APP_VERSION = "SET_IS_THE_OLD_APP_VERSION";